import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { OLAF } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { FREE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import UITrialActivationButton from 'ui-addon-upgrades/button/UITrialActivationButton';
import { getTrialUpgradeData } from 'pricing-pages-lib/utils/ebx642Utils';
import { APP, SCREENS } from '../../constants/tracking/Locations';
import SuiteFeatureTableBadge from '../common/SuiteFeatureTableBadge';
import CurrentPlanButton from '../suite-starter-page/CurrentPlanButton';
const TableHeaderCell = styled.th.withConfig({
  displayName: "CompareProFeatureTableHeaderCell__TableHeaderCell",
  componentId: "sc-4f2t71-0"
})(["text-align:center;font-weight:normal;position:relative;background-color:", ";box-shadow:", ";width:", ";padding:16px 0;vertical-align:bottom;"], ({
  isStaticHeader,
  isHighlightedCell
}) => !isStaticHeader && isHighlightedCell && `${OLAF}`, ({
  isStaticHeader,
  isHighlightedCell
}) => !isStaticHeader && isHighlightedCell && 'inset 0px 4px 4px rgba(124, 152, 182, 0.2)', ({
  columns
}) => columns < 3 ? `calc(50%/${columns})` : `calc(70%/${columns})`);
const badgeStyle = {
  top: '16px',
  left: 0,
  right: 0,
  margin: '12px auto',
  width: 'fit-content'
};
const ctaStyles = {
  width: '212px',
  padding: '11px'
};

const CompareProFeatureTableHeaderCell = ({
  productLevel,
  columns,
  productLine,
  isStaticHeader
}) => {
  const isFree = productLevel === FREE;
  const isStarter = productLevel === STARTER;
  const isHighlightedCell = PROFESSIONAL === productLevel;
  return /*#__PURE__*/_jsxs(TableHeaderCell, {
    isHighlightedCell: isHighlightedCell,
    columns: columns,
    scope: "col",
    isStaticHeader: isStaticHeader,
    children: [isHighlightedCell ? /*#__PURE__*/_jsx(SuiteFeatureTableBadge, {
      use: 'new',
      translationKey: 'recommended',
      badgeStyle: badgeStyle
    }) : null, /*#__PURE__*/_jsx("strong", {
      className: "m-y-1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        className: "flex-column m-y-4",
        message: `merchCards.businessObjectives.suite.${productLevel}.${productLine}.title`
      })
    }), isFree || isStarter ? /*#__PURE__*/_jsx(CurrentPlanButton, {
      ctaStyles: Object.assign({}, ctaStyles, {
        visibility: 'visible'
      }),
      i18nKey: `EBX642.${productLine.toLowerCase()}.table.ctaDisabled`
    }) : /*#__PURE__*/_jsx(UITrialActivationButton, {
      upgradeData: getTrialUpgradeData({
        app: APP,
        screen: SCREENS.COMPARE_PROFESSIONAL,
        productLine
      }),
      block: true,
      use: "primary",
      style: ctaStyles
    })]
  }, productLevel);
};

export default CompareProFeatureTableHeaderCell;